import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
//import Paper from '@material-ui/core/Paper'

import FileInput from '@team-griffin/react-file-input'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import IconButton from '@material-ui/core/IconButton'
import withWidth from '@material-ui/core/withWidth'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/Add'

import PhotoDialog from './PhotoDialog'

import { connect } from 'react-redux'
import { API_URL, uploadPhotos } from '../../utils/api'
import { handleSaveOffice } from '../../actions/offices'

const styles = theme => ({
  root: {
    width: 'calc(100% - 40px)',
    margin: '20px',
    paddingBottom: '55px',
    [theme.breakpoints.down('xs')]: {
    	width: '100%',
      margin: '0',
      paddingBottom: '80px',
    }
  },
  editButton: {
  	color: 'rgba(255, 255, 255, 0.87)'
  },
  addButton: {
  	position: 'fixed',
  	bottom: '15px',
  	right: '15px'
  },
  noPhotosText: {
    width: '100%',
  	[theme.breakpoints.down('xs')]: {
    	margin: '16px'
    }
  }
})

const getColWidth = (bp) => {
  let col

  if (bp === 'xl') col = 4
  if (bp === 'lg') col = 3
  if (bp === 'md') col = 2
  if (bp === 'xs') col = 1

  return col
}

class GalleryTab extends Component {
	state = {
		photos: [],
		newPhotos: [],
		openPhotoDialog: false,
		photoData: {}
	}

	componentDidMount () {
    const { photos, newPhotos } = this.props

    //console.log(newPhotos)

    this.setState({
    	photos,
    	newPhotos
    })
  }

  componentDidUpdate (prevProps) {
    const { offices, officeId } = this.props

    if (this.state.photos !== offices[officeId].photos) {
	    this.setState({
	    	photos: offices[officeId].photos
	    })
	  }
  }

  handlePhotoDialogOpen = (event, photoId) => {
  	const { photos } = this.state
  	const index = photos.findIndex(photo => photo.id === photoId)
  	const photoData = photos[index]

    this.setState({
    	openPhotoDialog: true,
    	photoData
    })
  }

  handlePhotoDialogClose = () => {
    this.setState({ openPhotoDialog: false });
  }

  handleUpload = e => {
  	const { dispatch, officeId, userId } = this.props
  	const { newPhotos } = this.state
    const files = Array.from(e.target.files)

    const formData = new FormData()

    files.forEach((file, i) => {
      formData.append(i, file, file.name)
    })

		uploadPhotos(formData)
    	.then((uploadedPhotos) => {
    		//console.log(photos)
    		const photos = [...newPhotos, ...uploadedPhotos]

    		this.setState({
					newPhotos: photos
	      })
    	})
    	.then(() => {
    		dispatch(handleSaveOffice(officeId, JSON.stringify(this.state)))
    	})
  }

  render() {
    const { classes, width, officeId } = this.props
    const { photos, newPhotos, photoData, openPhotoDialog } = this.state

    return (
    	<Fragment>
	  		<div className={classes.root}>
	  			<GridList cols={getColWidth(width)} spacing={1} cellHeight={360}>
			      {photos && photos.map(photo => (
					    <GridListTile key={photo.id}>
					      <img src={photo.path} alt={photo.id} />
					      <GridListTileBar
					        //title={tile}
					        subtitle={photo.description}
					        actionIcon={
					          <IconButton className={classes.editButton} onClick={event => this.handlePhotoDialogOpen(event, photo.id)}>
					            <EditIcon />
					          </IconButton>
					        }
					      />
					    </GridListTile>
					  ))}
					  {newPhotos.map(photo => (
					    <GridListTile key={photo.id}>
					      <img src={`${API_URL}/tmp/${photo.filename}`} alt={photo.id} />
					      <GridListTileBar
					        subtitle='Waiting for approval...'
					      />
					    </GridListTile>
					  ))}
			    </GridList>

          {!photos && newPhotos.length === 0 && (
            <Typography gutterBottom className={classes.noPhotosText}>There are no photos. You can add new using button in the bottom right corner.</Typography>
          )}
	      </div>

	      {/*<input type='file' onChange={this.handleUpload} multiple />*/}

	      <FileInput
	      	id='uploadButton'
	      	//value={}
	      	multiple
	      	button={(
	      		<Button
		          variant="fab"
		          color='secondary'
		          className={classes.addButton}
		        >
		          <AddIcon />
		        </Button>
	      	)}
	      	onChange={this.handleUpload}
	      />

	      <PhotoDialog data={photoData} officeId={officeId} open={openPhotoDialog} handleClose={this.handlePhotoDialogClose} />
      </Fragment>
    )
  }
}

GalleryTab.propTypes = {
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  photos: PropTypes.array.isRequired,
  newPhotos: PropTypes.array.isRequired
}

function mapStateToProps ({ authedUser, offices }) {
  return {
    userId: authedUser.id,
    offices
  }
}

export default connect(mapStateToProps)(withWidth()(withStyles(styles)(GalleryTab)))


// WEBPACK FOOTER //
// ./src/components/Offices/GalleryTab.js